import React, { useState, useContext, Fragment } from 'react';
import { useMutation, ApolloError, gql } from '@apollo/client';
import logError from '../../utils/airbrake';
import errorUtils from '../../utils/error';
import '../../styles/page/Login.scss';
import { GlobalNotificationContext } from '../context/GlobalNotification';
import {
  AuthPartnerEmailAccessMutation,
  AuthPartnerEmailAccessMutationVariables,
} from '../../gql/graphql';
import logoWhite from '../../images/storetasker-logo-white-with.png';

const authPartnerEmailAccessMutation = gql`
  mutation AuthPartnerEmailAccess($email: String!) {
    authPartnerEmailAccess(email: $email)
  }
`;

const PartnerLogin = () => {
  const { addNotification } = useContext(GlobalNotificationContext);
  const [loginState, setLoginState] = useState('login');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [tryLogin] = useMutation<
    AuthPartnerEmailAccessMutation,
    AuthPartnerEmailAccessMutationVariables
  >(authPartnerEmailAccessMutation, {
    variables: {
      email: email.trim(),
    },
  });

  function attemptLogin() {
    console.log('attemptLogin');
    if (loading) return;
    if (!email.trim()) {
      addNotification('Please enter your email.', undefined, 5000);
      return;
    }
    setLoading(true);
    tryLogin()
      .then(({ data }) => {
        setLoading(false);
        if (data && data.authPartnerEmailAccess) {
          if (data.authPartnerEmailAccess === 'SENT_LINK') {
            setLoginState('sent');
          } else if (data.authPartnerEmailAccess === 'EMAIL_INVALID') {
            addNotification(
              'This email looks incorrect. Please check your login info and try again.',
            );
          } else if (data.authPartnerEmailAccess === 'NEED_TO_SIGNUP') {
            addNotification(
              "Sorry! We couldn't find an existing account with that login information. Please try again.",
            );
          } else {
            addNotification(
              'Error! Please check your login info and submit again.',
            );
          }
        } else {
          addNotification(
            'An error occured, please contact support@storetasker.com',
          );
          logError('Mutation missing result authPartnerEmailAccess', {
            component: 'PartnerLogin',
            func: 'authPartnerEmailAccess',
          });
        }
      })
      .catch((err: ApolloError) => {
        setLoading(false);
        addNotification(errorUtils.getErrorMessage(err) || 'Login Error');
        logError(err, {
          component: 'PartnerLogin',
          func: 'attemptLogin',
        });
      });
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      attemptLogin();
    }
  }

  return (
    <div className="Login PartnerLogin">
      <div className="LoginLogoWrap">
        <img className="LoginLogo" src={logoWhite} alt="Storetasker Logo" />
      </div>
      <div
        className={
          'LoginHeader ' +
          (loginState === 'login' ? '' : ' LoginHeaderWithout ')
        }
      >
        <div className="LoginHeaderIntro">Welcome back!</div>
        <div className="LoginHeaderTitle">
          {loginState === 'login'
            ? 'Login to Your Partner Account'
            : 'Check Your Email For Access'}
        </div>
      </div>
      <div className="LoginBody">
        {loginState === 'login' && (
          <Fragment>
            <div className="LoginField">
              <div className="LoginFieldName">Email</div>
              <input
                type="email"
                className="LoginFieldInput"
                placeholder="email address"
                spellCheck="false"
                value={email}
                onChange={(e) => setEmail(e.target.value || '')}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div
              className={'LoginBtn ' + (loading ? ' LoginBtnLoading ' : '')}
              onClick={attemptLogin}
            >
              Log in
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default PartnerLogin;
